import { Routes, Route, Link } from "react-router-dom";

export default function About() {
    return (
      <>
        <div style={{margin: 30}}>
          <h2>About Activities@home</h2>
          <p>Activities@home is a simplified version of the Activities Web service (@work) that is currently used at deCODE.</p>

          <p>@home is designed for mobile interfaces and has real-time synchronisation so that employees can register hours on their phone or mobile device via a web browser.</p>

          <p>It's purpose is to give employees the opportunity to register hours when not on location at deCODE headquarters or at Þjónustumiðstöð rannsóknaverkefna, e.g. on vacation or leave.</p>

          <p>It is not meant as a substitute for the @work version and therefore it has limits, such as the viewable history length.</p>

          <p>Contact the Payroll officer or Software support for questions or comments: softwaresupport@decode.is</p>
          {/* {Window.localStorage.forEach(item => {
            <p>{JSON.stringify(item)}</p>
          })} */}
          {/* {JSON.stringify(localStorage)} */}
        </div>
      </>
    );
  }